import React from 'react';

import { func, object, string } from '@philips-emr/tws-core/lib/component/prop-types';
import { msg } from '@philips-emr/tws-core/lib/services/message-service';
import { isFunction } from '@philips-emr/tws-utils';

import { CountryFlag } from '.';

function CountryItem(props) {
  const { code, name, callingCode, style, onClick } = props;

  const onItemClick = () => (
    isFunction(onClick) && onClick({ name, code, callingCode })
  );

  return (
    <div className="c-phone-number-item" style={style} onClick={onItemClick}>
      <CountryFlag country={code} />
      <span className="c-phone-number-item__label">{msg(name)}</span>
      <span className="c-phone-number-item__calling-code">+{callingCode}</span>
    </div>
  );
}

CountryItem.propTypes = {
  code: string,
  callingCode: string,
  name: string,
  style: object,
  onClick: func,
};

export default CountryItem;
